import ajax from '@/utils/ajax';

// export function getlist(id) {
//     return ajax.get('course',{
//         params:{
//             userid:id
//         }
//     })
// }


//获取首页轮播图
export function getRotation() {
    return ajax.get('/website/hyWebsiteImg/findPutShelfList')
}

//获取首页信息
export function gethomeInfor() {
    return ajax.get('/website/hyWebsiteBasicInfo/list')
}

//查询未完成货源信息
export function notDoneOrder(params) {
    return ajax.get('/order/hyOrder/notDoneOrder',{
        params
    })
}

//查询车源信息
export function vehicleInfo(params) {
    return ajax.get('/hyVehicle/hyVehicle/vehicleInfo',{
        params
    })
}

//查询新闻列表为实时评论
export function queryUsedNews(params) {
    return ajax.get('/evaluation/hyEvaluation/listPc?pageNo=1&pageSize=5&column=createTime&order=desc',{
        params
    })
}

//查询公司新闻为投诉处理
export function queryUsedNewsgongsi(params) {
    return ajax.get('/complaint/hyComplaint/listPc?pageNo=1&pageSize=3&column=createTime&order=desc',{
        params
    })
}

// //查询新闻列表
// export function queryUsedNews(params) {
//     return ajax.get('/website/hyWebsiteNews/queryUsedNews',{
//         params
//     })
// }

//根据运单号查询运单信息
export function shippingNum(params) {
    return ajax.get('/shipping/hyShippingNote/findInfoByShippingNum',{
        params
    })
}

//新闻详情
export function newsdetails(params) {
    return ajax.get('/website/hyWebsiteNews/queryById',{
        params
    })
}

//消息通知列表
export function jlSmsHistory(params) {
    return ajax.get('/api/wlhy/jlSmsHistory/list',{
        params
    })
}
//通知详情
export function gettongzxq(params) {
    return ajax.get('/api/wlhy/jlSmsHistory/queryById',{
        params
    })
}


